module.exports = __webpack_public_path__ + "static/media/py.c5bbbec1.svg";